import React, { useState } from 'react';
import axios from 'axios';

import PropTypes from 'prop-types';

import './styles.scss';

export default function Login({ setToken, connected }) {

    const [email, setEmail] = useState();
    const [password, setPassword] = useState();

    const handleOnChange = (event) => {
        if (event.target.className === 'email') {
            setEmail(event.target.value)
        } else if (event.target.className === 'password') {
            setPassword(event.target.value)
        }
    };

    const handleSubmit = function (evt) {
        evt.preventDefault();
        const options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/login`,
            headers: { 'Content-Type': 'application/json' },
            data: { 
                email: email, password: password 
            }
        };
        axios.defaults.withCredentials = true
        axios.request(options).then(function (response) {
                setToken(response.data.token);
        }).catch(function (error) {
            console.error(error);
        });

    }

    return (
        <div className="login-wrapper">
            <h1>Please Log In</h1>
            <form onSubmit={handleSubmit}>
                <label>
                    <p>Email</p>
                    <input className='email' type="text" onChange={handleOnChange} />
                </label>
                <label>
                    <p>Password</p>
                    <input className='password' type="password" onChange={handleOnChange} />
                </label>
                <div>
                    <button type="submit">Connexion</button>
                    {connected && (
                        <>
                            <div>TOTOTOTOTOOTOTOTOT</div>
                        </>
                    )}
                </div>
            </form>
        </div>
    );
}

Login.propTypes = {
    setToken: PropTypes.func.isRequired,
    connected: PropTypes.bool.isRequired
};